import { makeAutoObservable, runInAction } from 'mobx';
import {
  IShopContractType,
  IShopContractTypeParams,
} from 'src/@types/Choqorak/Settings/ShopContractType';
import agent from 'src/api/agent';
export default class ShopContractTypeStore {
  openDialog = false;

  ShopContractTypeRegistry = new Map<number, IShopContractType>();

  editMode = false; //When click on edit button

  selectedShopContractType: IShopContractType | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get ShopContractTypeList() {
    return Array.from(this.ShopContractTypeRegistry.values());
  }

  setShopContractTypeList = (ShopContractType: IShopContractType) => {
    this.ShopContractTypeRegistry.set(ShopContractType.id!, ShopContractType);
  };

  //Pagination
  loadShopContractType = async (params: IShopContractTypeParams) => {
    // this.ShopContractTypeRegistry.clear();
    try {
      const result = await agent.ShopContractType.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setShopContractTypeList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ShopContractTypeSearch = async (params: IShopContractTypeParams) => {
   this.ShopContractTypeRegistry.clear();
    this.loadShopContractType(params);
  };

  getShopContractTypeFromRegistry = (id: number) => {
    let ShopContractType = this.ShopContractTypeRegistry.get(id);
    if (ShopContractType) {
      this.editMode = true;
      this.selectedShopContractType = ShopContractType;
    }
  };

  clearSelectedShopContractType = () => {
    this.editMode = false;
    this.selectedShopContractType = undefined;
  };

  deleteShopContractType = async (id: number, remark?: string) => {
    await agent.ShopContractType.delete(id, remark!);
    runInAction(() => {
      this.ShopContractTypeRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createShopContractType = async (ShopContractType: IShopContractType) => {
    await agent.ShopContractType.create(ShopContractType);
    runInAction(() => {
      this.loadShopContractType({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedShopContractType();
    });
  };

  updateShopContractType = async (ShopContractType: IShopContractType) => {
    await agent.ShopContractType.update(ShopContractType);

    runInAction(() => {
      this.loadShopContractType({ pageIndex: 0, pageSize: 5 });
      this.ShopContractTypeRegistry.delete(ShopContractType.id!);
      this.ShopContractTypeRegistry.set(ShopContractType.id!, ShopContractType);
      this.clearSelectedShopContractType();
    });
  };
}
